import React, { useState } from "react";
import { useLanguage } from "../LanguageProvider";
import Modal from "../Modal";
import MitTartalmaz from "../pages/MitTartalmaz";

export default function Footer() {
  const { dict } = useLanguage();
  const [faqModalOpen, setFaqModalOpen] = useState(false);

  return (
    <>
      <footer className="relative bg-gradient-to-b from-[#0a0a0a] via-[#1a1a1a] to-black text-white py-12 md:py-20 border-t border-white/10 pb-24 md:pb-12 overflow-hidden">
        {/* Background Effects */}
        <div className="absolute inset-0">
          <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary/5 rounded-full blur-3xl"></div>
          <div className="absolute top-0 right-0 w-96 h-96 bg-green-500/5 rounded-full blur-3xl"></div>
        </div>
        
        <div className="max-w-7xl mx-auto px-4 relative z-10">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
            {/* Logo és céginfo */}
            <div className="md:col-span-2 space-y-6">
              <img src="/logo_ai.png" alt="HoppHomes logó" className="h-14 md:h-16" />
              <p className="text-gray-300 text-base leading-relaxed max-w-md">
                Kulcsrakész moduláris otthonok prémium minőségben. Okos megoldások, modern dizájn, energiahatékony technológia.
              </p>
              <div className="flex flex-col gap-2">
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M4 4a2 2 0 012-2h8a2 2 0 012 2v12a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm3 1h6v4H7V5zm6 6H7v2h6v-2z" clipRule="evenodd"/>
                  </svg>
                  <span>Üzemeltető: HOPPX LTD</span>
                </div>
                <div className="flex items-center gap-2 text-sm text-gray-400">
                  <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M5.05 4.05a7 7 0 119.9 9.9L10 18.9l-4.95-4.95a7 7 0 010-9.9zM10 11a2 2 0 100-4 2 2 0 000 4z" clipRule="evenodd"/>
                  </svg>
                  <span>London, Egyesült Királyság</span>
                </div>
              </div>
            </div>

            {/* Szolgáltatások */}
            <div className="space-y-6">
              <h3 className="text-white font-black text-xl mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">Szolgáltatások</h3>
              <ul className="space-y-3">
                <li>
                  <a href="/mobilhazak" className="group flex items-center gap-2 text-gray-300 hover:text-secondary transition-colors">
                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    Moduláris otthonok
                  </a>
                </li>
                <li>
                  <a href="/kesz-hazak" className="group flex items-center gap-2 text-gray-300 hover:text-secondary transition-colors">
                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    Kész házak
                  </a>
                </li>
                <li>
                  <a href="/hopp-proconcept" className="group flex items-center gap-2 text-gray-300 hover:text-secondary transition-colors">
                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    Hopp ProConcept
                  </a>
                </li>
                <li>
                  <a href="/egyedi-hazak" className="group flex items-center gap-2 text-gray-300 hover:text-secondary transition-colors">
                    <svg className="w-4 h-4 transform group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                    Egyedi tervezés
                  </a>
                </li>
              </ul>
            </div>

            {/* Hasznos linkek */}
            <div className="space-y-6">
              <h3 className="text-white font-black text-xl mb-4 bg-gradient-to-r from-white to-gray-400 bg-clip-text text-transparent">Hasznos linkek</h3>
              <ul className="space-y-3">
                <li>
                  <button 
                    onClick={() => setFaqModalOpen(true)}
                    className="hover:text-secondary transition-colors text-left"
                  >
                    GYIK - Gyakori Kérdések
                  </button>
                </li>
                <li><a href="#" className="hover:text-secondary transition-colors">ÁSZF</a></li>
                <li><a href="#" className="hover:text-secondary transition-colors">Adatvédelmi szabályzat</a></li>
                <li><a href="#" className="hover:text-secondary transition-colors">Garanciális feltételek</a></li>
              </ul>
            </div>

            {/* Kapcsolat - hidden on mobile */}
            <div className="hidden md:block space-y-4">
              <h3 className="text-white font-bold text-lg">Kapcsolat</h3>
              <div className="space-y-2 text-gray-400 text-sm">
                <p>📧 hoppxplatform@gmail.com</p>
                <p>📍 London, Egyesült Királyság</p>
                <div className="flex space-x-4 mt-4">
                  <a href="#" className="text-gray-400 hover:text-secondary transition-colors">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z"/>
                    </svg>
                  </a>
                  <a href="#" className="text-gray-400 hover:text-secondary transition-colors">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M22.46 6c-.77.35-1.6.58-2.46.69.88-.53 1.56-1.37 1.88-2.38-.83.5-1.75.85-2.72 1.05C18.37 4.5 17.26 4 16 4c-2.35 0-4.27 1.92-4.27 4.29 0 .34.04.67.11.98C8.28 9.09 5.11 7.38 3 4.79c-.37.63-.58 1.37-.58 2.15 0 1.49.75 2.81 1.91 3.56-.71 0-1.37-.2-1.95-.5v.03c0 2.08 1.48 3.82 3.44 4.21a4.22 4.22 0 0 1-1.93.07 4.28 4.28 0 0 0 4 2.98 8.521 8.521 0 0 1-5.33 1.84c-.34 0-.68-.02-1.02-.06C3.44 20.29 5.7 21 8.12 21 16 21 20.33 14.46 20.33 8.79c0-.19 0-.37-.01-.56.84-.6 1.56-1.36 2.14-2.23z"/>
                    </svg>
                  </a>
                  <a href="#" className="text-gray-400 hover:text-secondary transition-colors">
                    <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                      <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.174-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.402.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.357-.629-2.75-1.378l-.748 2.853c-.271 1.043-1.002 2.35-1.492 3.146C9.57 23.812 10.763 24.009 12.017 24.009c6.624 0 11.99-5.367 11.99-11.988C24.007 5.367 18.641.001 12.017.001z"/>
                    </svg>
                  </a>
                </div>
              </div>
            </div>

            {/* Mobile-only simplified footer */}
            <div className="md:hidden text-center space-y-3">
              <img src="/logo_ai.png" alt="HoppHomes" className="h-8 mx-auto" />
              <p className="text-gray-400 text-xs">Kulcsrakész prémium mobilházak</p>
              <p className="text-gray-500 text-xs">📧 hoppxplatform@gmail.com</p>
            </div>
          </div>

          {/* Legal Links Section */}
          <div className="border-t border-white/10 mt-4 md:mt-8 pt-4 md:pt-6">
            <div className="flex flex-col items-center space-y-2 md:space-y-0 md:flex-row md:justify-between">
              {/* Mobile: compact links */}
              <div className="flex flex-wrap justify-center gap-3 md:gap-6 text-xs md:text-sm">
                <a href="/impresszum" className="text-gray-500 hover:text-secondary">Impresszum</a>
                <a href="/jogi-nyilatkozat" className="text-gray-500 hover:text-secondary">Jogi nyilatkozat</a>
                <a href="/kapcsolat" className="text-gray-500 hover:text-secondary">Kapcsolat</a>
              </div>
              <div className="text-gray-600 text-xs md:text-sm">
                &copy; {new Date().getFullYear()} HOPPX LTD
              </div>
            </div>
          </div>
        </div>
      </footer>

      {/* FAQ Modal */}
      <Modal 
        open={faqModalOpen} 
        onClose={() => setFaqModalOpen(false)} 
        onBack={() => setFaqModalOpen(false)} 
        title="Gyakori Kérdések"
      >
        <MitTartalmaz />
      </Modal>
    </>
  );
}
